import { FloatInputField, FloatInputFieldProps } from '@brighte/form-components';
import { Text } from '@spark-web/text';
import { InputAdornment } from '@spark-web/text-input';
import { LABELS } from '@utils';

type RepaymentInput = FloatInputFieldProps & {
  period: 'monthly' | 'yearly';
  additionalLabel?: string;
  endLabel?: string;
};

function RepaymentInput({ period, additionalLabel, endLabel, ...props }: RepaymentInput) {
  const label = endLabel ?? (period === 'monthly' ? `monthly ${additionalLabel ?? ''}`.trim() : 'yearly');

  // When the group already provides a heading this field's own label is hidden, but keep a real label
  // for assistive technology rather than an empty string, and don't reserve vertical space for it.
  const fieldLabel = props.label || LABELS.AMOUNT;
  const FieldProps = props.label ? props.FieldProps : { ...props.FieldProps, labelVisibility: 'hidden' as const };

  return (
    <FloatInputField {...props} label={fieldLabel} FieldProps={FieldProps}>
      <InputAdornment placement="start">
        <Text>$</Text>
      </InputAdornment>
      <InputAdornment placement="end">
        <Text>{label}</Text>
      </InputAdornment>
    </FloatInputField>
  );
}

export { RepaymentInput };
